import React, { useEffect, useState, memo } from 'react';
import { useSelector } from 'react-redux';
import { useFilteredSites } from '../util/helper-functions';
import SearchFilter from './search-filter';
import DirectorySearchFilter from './directory-search-filter';
import LiveCounter from './live-counter';
import SitesGrid from './sites-grid';
import OtherFilters from './site-other-filters';
import GridSkeleton from './sites-grid-skeleton';
import './style.scss';

const Layout = () => {
	const sites = useFilteredSites();
	const { pageBuilder, searchTerm, showSearchBox } = useSelector(
		( state ) => state
	);
	const [ siteData, setSiteData ] = useState( {
		gridSkeleton: false,
		sites,
	} );

	useEffect( () => {
		if ( showSearchBox && searchTerm ) {
			setSiteData( {
				...siteData,
				sites,
				gridSkeleton: true,
			} );
		} else {
			setSiteData( {
				...siteData,
				sites,
			} );
		}
	}, [ pageBuilder ] );

	return (
		<>
			<LiveCounter />
			<DirectorySearchFilter />
			<SearchFilter siteData={ siteData } setSiteData={ setSiteData } />
			<div id="st-showcase-content-root" className="">
				<div className="st-templates-content">
					<OtherFilters
						siteData={ siteData }
						setSiteData={ setSiteData }
					/>
					{ siteData.gridSkeleton ? (
						<GridSkeleton column={ 3 } />
					) : (
						<SitesGrid column={ 3 } sitesData={ siteData.sites } />
					) }
				</div>
			</div>
		</>
	);
};

export default memo( Layout );
